module.exports = __webpack_public_path__ + "img/flow.50ac9e04.png";